import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AnnualitService } from './api/annualit.service';
import { AssistenzaService } from './api/assistenza.service';
import { AutenticazioneService } from './api/autenticazione.service';
import { DataEOraService } from './api/dataEOra.service';
import { EmailService } from './api/email.service';
import { MenuService } from './api/menu.service';
import { PagoPAWebhookService } from './api/pagoPAWebhook.service';
import { PasskeyWebAuthnService } from './api/passkeyWebAuthn.service';
import { PastiDaPreparareService } from './api/pastiDaPreparare.service';
import { RicaricheService } from './api/ricariche.service';
import { ScuoleService } from './api/scuole.service';
import { SincronizzazioniService } from './api/sincronizzazioni.service';
import { StudentiService } from './api/studenti.service';
import { UtentiService } from './api/utenti.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AnnualitService,
    AssistenzaService,
    AutenticazioneService,
    DataEOraService,
    EmailService,
    MenuService,
    PagoPAWebhookService,
    PasskeyWebAuthnService,
    PastiDaPreparareService,
    RicaricheService,
    ScuoleService,
    SincronizzazioniService,
    StudentiService,
    UtentiService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
